import { render, staticRenderFns } from "./bulma_locate.vue?vue&type=template&id=4153772e&scoped=true&lang=html"
import script from "./bulma_locate.vue?vue&type=script&lang=js"
export * from "./bulma_locate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4153772e",
  null
  
)

export default component.exports